import { render, staticRenderFns } from "./AppModal.vue?vue&type=template&id=25b8d2d5&"
import script from "./AppModal.vue?vue&type=script&lang=js&"
export * from "./AppModal.vue?vue&type=script&lang=js&"
import style0 from "./AppModal.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports